<h2 mat-dialog-title>Bloquer une DB</h2>

<form [formGroup]="form">
  <div mat-dialog-content class="dialog-content">
    <mat-form-field appearance="outline">
      <mat-label>Group ID</mat-label>
      <input matInput formControlName="groupId" />
      @if (hasGroupIdError) {
        <mat-error>
          @if (groupIdControl.hasError('required')) {
            Le Group ID est obligatoire.
          } @else if (hasInvalidGroupIdError) {
            Le Group ID doit se terminer par un UUID valide.
          }
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Type de blocage</mat-label>
      <mat-select formControlName="overrideType">
        @for (option of overrideTypes; track option.value) {
          <mat-option [value]="option.value">{{ option.label }}</mat-option>
        }
      </mat-select>
      @if (hasOverrideTypeError) {
        <mat-error>Le type de blocage est obligatoire.</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Raison</mat-label>
      <textarea matInput formControlName="reason" maxlength="255" rows="4"></textarea>
      @if (hasReasonError) {
        <mat-error>
          @if (reasonControl.hasError('required')) {
            La raison est obligatoire.
          } @else if (reasonControl.hasError('minlength')) {
            La raison doit contenir au moins 3 caractères.
          }
        </mat-error>
      }
    </mat-form-field>
  </div>

  <div mat-dialog-actions align="end">
    <button mat-button type="button" (click)="closeDialog()">Annuler</button>
    <button mat-flat-button color="primary" type="button" [disabled]="!canSubmit" (click)="addGroupOverride()">Bloquer la DB</button>
  </div>
</form>
